<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/generation.svg" />
          </div>
          <div>
            <div class="card_title_1">
              ADDITIONAL GENERATION CAPACITY - PROJECT MANAGEMENT
            </div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div class="card-body" style="padding: 20px">
      <div class="row">
        <div class="col-md-5">
          <div
            class="card"
            style="
              box-shadow: none;
              border-radius: 8px;
              background-color: #efefef;
            "
          >
            <div class="card-body">
              <div
                class="text mb-4 d-flex"
                style="justify-content: space-between; align-items: center"
              >
                <h5 class="title">THERMAL GENERATION CAPACITY</h5>
                <div>
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabThermal === 'all' }"
                    @click="selectTabThermal('all')"
                    >All</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabThermal === 'ipp' }"
                    @click="selectTabThermal('ipp')"
                    >IPP</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabThermal === 'pln' }"
                    @click="selectTabThermal('pln')"
                    >PLN</span
                  >
                </div>
              </div>
              <div class="row" style="height: 250px">
                <div class="col-md-6" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[0]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabThermal,
                        'Thermal',
                        'all'
                      )
                    "
                    style="margin-bottom: 20px; height: 100%"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-6" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[1]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabThermal,
                        'Thermal',
                        'PLTU'
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[2]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabThermal,
                        'Thermal',
                        'Gas Based'
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div
            class="card"
            style="
              box-shadow: none;
              border-radius: 8px;
              background-color: #efefef;
            "
          >
            <div class="card-body">
              <div
                class="text mb-4 d-flex"
                style="justify-content: space-between; align-items: center"
              >
                <h5 class="title">EBT GENERATION CAPACITY</h5>
                <div>
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabEbt === 'all' }"
                    @click="selectTabEbt('all')"
                    >All</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabEbt === 'ipp' }"
                    @click="selectTabEbt('ipp')"
                    >IPP</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabEbt === 'pln' }"
                    @click="selectTabEbt('pln')"
                    >PLN</span
                  >
                </div>
              </div>
              <div class="row" style="height: 250px">
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[0]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabEbt,
                        'EBT',
                        'all'
                      )
                    "
                    style="margin-bottom: 20px; height: 100%"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[1]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabEbt,
                        'EBT',
                        'Hydro'
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>

                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[2]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabEbt,
                        'EBT',
                        'Solar'
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[3]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabEbt,
                        'EBT',
                        'Geothermal'
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>

                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[4]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        selectedTabEbt,
                        'EBT',
                        'Other'
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardAdditionalGenerationCapacity from "./CardAdditionalGenerationCapacity.vue";
import GenerationService from "@/services/generation/generation";
const apiGeneration = GenerationService.build();

export default {
  props: ["last_update", "data"],
  components: {
    CardAdditionalGenerationCapacity,
  },
  data() {
    return {
      modalGenerationCapacity: {
        show: false,
        load: false,
      },
      thermal: [],
      ebt: [],

      selectedTabThermal: "all",
      selectedTabEbt: "all",

      filter: {
        owner: "",
        type: "",
        category: "",
      },

      projects: [
        {
          name: "PLTP - Muara Laboh (FTP2)#2 - 80 MW - 2025 - #2 - Sumatera Barat - 4540",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "80.00",
        },
        {
          name: "PLTP - Lumut Balai (FTP2) #2 - 55 MW - 2022 - #2 - Sumatera Selatan - 4612",
          stage: "Konstruksi",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "55.00",
        },
        {
          name: "PLTP - Rajabasa (FTP2) #1 - 110 MW - 2025 - #1 - Lampung - 4268",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "110.00",
        },
        {
          name: "PLTP - Rajabasa (FTP2) #2 - 110 MW - 2029 - #2 - Lampung - 4269",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "110.00",
        },
        {
          name: "PLTP - Rantau Dadap (FTP2)#1 - 86 MW - 2021 - #1 - Sumatera Selatan - 4628",
          stage: "COD",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "86.00",
        },
        {
          name: "PLTP - Baturaden (FTP2) - 110 MW - 2028 - #1 - Jawa Tengah - 4150",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "110.00",
        },
        {
          name: "PLTP - Rantau Dadap (FTP2)#2 - 134 MW - 2025 - #2 - Sumatera Selatan - 4630",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "134.00",
        },
        {
          name: "PLTA - Batang Toru (Tapsel) - 510 MW - 2025 - #1 - Sumatera Utara - 4831",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "510.00",
        },
        {
          name: "PLTA - Buttu Batu - 100 MW - 2027 - #1 - Sulawesi Selatan - 8644",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "100.00",
        },
        {
          name: "PLTA - Buttu Batu - 100 MW - 2027 - #2 - Sulawesi Selatan - 8645",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "100.00",
        },
        {
          name: "PLTP - Sorik Marapi (FTP2) #3 - 50 MW - 2022 - #3 - Sumatera Utara - 8721",
          stage: "COD",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "50.00",
        },
        {
          name: "PLTS - Cirata - 145 MW - 2022 - #1 - Jawa Barat - 10021",
          stage: "COD",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "145.00",
        },
        {
          name: "PLTA - Merangin - 350 MW - 2025 - #1 - Jambi - 12379",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "350.00",
        },
        {
          name: "PLTP - Sorik Marapi (FTP2) #4 - 50 MW - 2023 - #4 - Sumatera Utara - 12398",
          stage: "Konstruksi",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "50.00",
        },
        {
          name: "PLTP - Sorik Marapi (FTP2) #5 - 50 MW - 2024 - #5 - Sumatera Utara - 12399",
          stage: "Procurement Planning",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "50.00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 100 MW - 2025 - #1 - Jawa Tengah - 12422",
          stage: "Procurement Planning",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "100.00",
        },
        {
          name: "PLTA - Sulbagsel (Kuota) Tersebar - 200 MW - 2028 - #1 - Sulawesi Selatan - 12649",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "200,00",
        },
        {
          name: "PLTB - Sulbagsel (Kuota) Tersebar - 60 MW - 2024 - #1 - Sulawesi Selatan - 12650",
          stage: "Procurement",
          type: "Other",
          category: "EBT",
          owner: "IPP	",
          capacity: "60,00",
        },
        {
          name: "PLTA - Poso Peaker - 200 MW - 2021 - #3 - Sulawesi Tengah - 12652",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "200,00",
        },
        {
          name: "PLTA - Sulbagsel (Kuota) Tersebar - 200 MW - 2030 - #1 - Sulawesi Selatan - 13002",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "IPP	",
          capacity: "200,00",
        },
        {
          name: "PLTS - Surya Sumatera (Kuota) Tersebar / PLTS Terapung Singkarak 50 MW - 48 MW - 2025 - #1 - Sumatera Utara - 13239",
          stage: "Procurement",
          type: "Solar",
          category: "	EBT",
          owner: "IPP	",
          capacity: "48,00",
        },
        {
          name: "PLTA - Hidro Sumatera (kuota) tersebar 250 MW - 90 MW - 2025 - #1 - Aceh - 13255",
          stage: "Procurement",
          type: "	Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "90,00",
        },
        {
          name: "PLTA - Hidro Sumatera (kuota) tersebar 250 MW - 160 MW - 2028 - #1 - Sumatera Utara - 13258",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "IPP	",
          capacity: "160,00",
        },
        {
          name: "PLTA - Hidro Sumatera (kuota) tersebar - 400 MW - 2030 - #1 - Bengkulu - 13261",
          stage: "OBC",
          type: "	Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "400,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 100 MW - 2024 - #1 - Jawa Barat - 13435",
          stage: "Procurement",
          type: "Solar",
          category: "EBT",
          owner: "IPP	",
          capacity: "100,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 100 MW - 2024 - #1 - Jawa Timur - 13491",
          stage: "OBC",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "100,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 150 MW - 2025 - #1 - Banten - 13515",
          stage: "OBC",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "150,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 140 MW - 2025 - #1 - Jawa Barat - 13516",
          stage: "OBC",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "140,00",
        },
        {
          name: "PLTA - Sulbagsel (Kuota) Tersebar - 200 MW - 2029 - #1 - Sulawesi Selatan - 13747",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "200,00",
        },
        {
          name: "PLTB - Sulbagsel (Kuota) Tersebar - 70 MW - 2026 - #1 - Sulawesi Selatan - 13749",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "IPP",
          capacity: "70,00",
        },
        {
          name: "PLTS - Dedieselisasi - 80.24 MW - 2023 - #1 - Sulawesi Tengah - 13750",
          stage: "Procurement",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "80,24",
        },
        {
          name: "PLTS - Dedieselisasi - 548.07 MW - 2023 - #1 - Maluku - 13792",
          stage: "Procurement",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "548,07",
        },
        {
          name: "PLTS - Dedieselisasi - 113.8 MW - 2025 - #1 - Papua - 13808",
          stage: "OBC",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "113,80",
        },
        {
          name: "PLTA - Bendungan Merangin PUPR - 107 MW - 2028 - #1 - Jambi - 13870",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "107,00",
        },
        {
          name: "PLTP - Muara Laboh (FTP2)#2 - 65 MW - 2028 - #3 - Sumatera Barat - 13878",
          stage: "Procurement",
          type: "Geothermal",
          category: "EBT",
          owner: "IPP",
          capacity: "65,00",
        },
        {
          name: "PLTA - Jawa-Bali (Kuota) Tersebar - 190 MW - 2029 - #1 - Jawa Barat - 13926",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "190,00",
        },
        {
          name: "PLTA - Jawa-Bali (Kuota) Tersebar - 190 MW - 2029 - #2 - Jawa Barat - 13927",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "190,00",
        },
        {
          name: "PLTA - Jawa-Bali (Kuota) Tersebar - 190 MW - 2029 - #3 - Jawa Barat - 13928",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "190,00",
        },
        {
          name: "PLTA - Jawa-Bali (Kuota) Tersebar - 190 MW - 2029 - #4 - Jawa Barat - 13929",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "190,00",
        },
        {
          name: "PLTS - Dedieselisasi - 69.84 MW - 2023 - #1 - Kalimantan Barat - 14333",
          stage: "Procurement",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "69,84",
        },
        {
          name: "PLTA - Kalseltengtimra (Kuota) Tersebar - 200 MW - 2025 - #1 - Kalimantan Utara - 14360",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "200,00",
        },
        {
          name: "PLTA - Kalseltengtimra (Kuota) Tersebar - 100 MW - 2026 - #1 - Kalimantan Utara - 14361",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "100,00",
        },
        {
          name: "PLTA - Kalseltengtimra (Kuota) Tersebar - 200 MW - 2027 - #1 - Kalimantan Utara - 14362",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "IPP",
          capacity: "200,00",
        },
        {
          name: "PLTS - Kalseltengtimra (Kuota) Tersebar / PLTS IKN - 50 MW - 2025 - #1 - Kalimantan Timur - 14375",
          stage: "Procurement",
          type: "Solar",
          category: "EBT",
          owner: "IPP",
          capacity: "50,00",
        },
        {
          name: "PLTP - Hululais (FTP2) - 55 MW - 2025 - #1 - Bengkulu - 4032",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Geothermal",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTP - Hululais (FTP2) - 55 MW - 2025 - #2 - Bengkulu - 4033",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Geothermal",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTP - Sungai Penuh (FTP2) - 55 MW - 2025 - #2 -  - 4068",
          stage: "OBC",
          type: "Geothermal",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Bakaru 2 - 70 MW - 2025 - #1 - Sulawesi Selatan - 4597",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "70,00",
        },
        {
          name: "PLTA - Bakaru 2 - 70 MW - 2025 - #2 - Sulawesi Selatan - 4598",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "70,00",
        },
        {
          name: "PLTA - Matenggeng PS - 235.75 MW - 2028 - #1 -  - 4153",
          stage: "OBC",
          type: "	Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "235,75",
        },
        {
          name: "PLTA - Asahan III (FTP2) - 87 MW - 2023 - #1 - Sumatera Utara - 4690",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "87,00",
        },
        {
          name: "PLTA - Matenggeng PS - 235.75 MW - 2028 - #2",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "235,75",
        },
        {
          name: "PLTA - Matenggeng PS - 235.75 MW - 2028 - #3",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "235,75",
        },
        {
          name: "PLTA - Matenggeng PS - 235.75 MW - 2028 - #4",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "235,75",
        },
        {
          name: "PLTA - Kelai - 55 MW - 2025 - #1 - Kalimantan Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Upper Cisokan Pump Storage (FTP2) - 260 MW - 2025 - #1 - Jawa Barat",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "260,00",
        },
        {
          name: "PLTA - Upper Cisokan Pump Storage (FTP2) - 260 MW - 2025 - #2 - Jawa Barat",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "260,00",
        },
        {
          name: "PLTA - Upper Cisokan Pump Storage (FTP2) - 260 MW - 2025 - #3 - Jawa Barat",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "260,00",
        },
        {
          name: "PLTA - Upper Cisokan Pump Storage (FTP2) - 260 MW - 2025 - #4 - Jawa Barat",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "260,00",
        },
        {
          name: "PLT EBT Base - Jayapura 2 - 50 MW - 2029 - #1 - Papua",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - Kalbar - 100 MW - 2027 - #1",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLT EBT Base - Lombok 3 - 50 MW - 2026 - #1 - Nusa Tenggara Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - Lombok 3 - 50 MW - 2027 - #2 - Nusa Tenggara Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - Sulbagut 3 - 100 MW - 2027 - #1 - Sulawesi Utara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLT EBT Base - Sulbagut 3 - 100 MW - 2028 - #2 - Sulawesi Utara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLT EBT Base - Timor 2 - 50 MW - 2026 - #1 - Nusa Tenggara Timur",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - Timor 3 - 50 MW - 2028 - #2 - Nusa Tenggara Timur",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLTA - Sumatera Pump Storage-1 - 250 MW - 2029 - #1 - Sumatera Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTA - Grindulu - 250 MW - 2030 - #1 - Jawa Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTA - Grindulu - 250 MW - 2030 - #2 - Jawa Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTA - Grindulu - 250 MW - 2030 - #3 - Jawa Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTA - Grindulu - 250 MW - 2030 - #4 - Jawa Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTA - Asahan III (FTP2) - 87 MW - 2024 - #2 - Sumatera Utara",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "87,00",
        },
        {
          name: "PLTP - PLTP Kepahiang - 55 MW - 2028 - #1 - Bengkulu",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Geothermal",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTB - Banten - 100 MW - 2024 - #1 - Banten",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTP - Kepahiang #2 - 55 MW - 2028 - #1 - Bengkulu",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Geothermal",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Simonggo - 90 MW - 2029 - #1 - Sumatera Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "90,00",
        },
        {
          name: "PLTA - Sumatera Pump Storage-1 - 250 MW - 2030 - #1 - Sumatera Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTB - Banten - 100 MW - 2025 - #1 - Banten",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 180 MW - 2025 - #1 - Jawa Barat",
          stage: "Centralized Planning",
          type: "Solar",
          category: "EBT",
          owner: "PLN",
          capacity: "180,00",
        },
        {
          name: "PLTS - Jawa-Bali (Kuota) Tersebar - 250 MW - 2025 - #1 - Jawa Timur",
          stage: "OBC",
          type: "Solar",
          category: "EBT",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLT EBT Base - Lombok 4 - 50 MW - 2028 - #1 - Nusa Tenggara Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - Lombok 4 - 50 MW - 2029 - #1 - Nusa Tenggara Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLT EBT Base - EBT Base Bintan - 100 MW - 2029 - #1 - Kepulauan Riau",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLT EBT Base - EBT Base Bintan - 100 MW - 2030 - #1 - Kepulauan Riau",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTB - Pembangkit Bayu - 55 MW - 2024 - #1 - Aceh",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTB - Pembangkit Bayu - 55 MW - 2025 - #2 - Sumatera Utara",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Tanjung Sakti - 114 MW - 2029 - #1 - Sumatera Selatan",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "114,00",
        },
        {
          name: "PLT Lain - BESS Sumatera* - 150 MW - 2030 - #1 - Sumatera Utara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "150,00",
        },
        {
          name: "PLT Lain - BESS Sumatera* - 150 MW - 2030 - #1 - Lampung",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "150,00",
        },
        {
          name: "PLTA - Tabang - 90 MW - 2028 - #1 - Kalimantan Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "90,00",
        },
        {
          name: "PLTA - Nanga Pinoh - 100 MW - 2029 - #1 - Kalimantan Barat",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTA - Sesayap - 90 MW - 2028 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "90,00",
        },
        {
          name: "PLTA - Kaltimra - 200 MW - 2029 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "200,00",
        },
        {
          name: "PLTA - Kaltimra - 100 MW - 2030 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLT EBT Base - Ambon - 25 MW - 2030 - #1 - Maluku",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "25,00",
        },
        {
          name: "PLT EBT Base - Ambon - 25 MW - 2030 - #2",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "25,00",
        },
        {
          name: "PLT EBT Base - Bau-Bau 2 - 15 MW - 2027 - #1 - Sulawesi Tenggara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "15,00",
        },
        {
          name: "PLT EBT Base - Bau-Bau 2 - 15 MW - 2028 - #2 - Sulawesi Tenggara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "15,00",
        },
        {
          name: "PLT EBT Base - PLT EBT Base Belitung (Kuota) tersebar* - 30 MW - 2029 - #1 - Kepulauan Bangka Belitung",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "30,00",
        },
        {
          name: "PLT EBT Base - Sorong 3 - 25 MW - 2029 - #1 - Papua Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "25,00",
        },
        {
          name: "PLT EBT Base - Sorong 3 - 25 MW - 2029 - #2",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "25,00",
        },
        {
          name: "PLTA - Baliem - 10 MW - 2029 - #1 - Papua",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTA - Hidro Sumatera (kuota) tersebar / PLTA Krueng Isep 10 MW - 10 MW - 2022 - #1 - Aceh",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTA - Jatigede (FTP2) - 55 MW - 2021 - #1 - Jawa Barat",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Jatigede (FTP2) - 55 MW - 2021 - #2 - Jawa Barat",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "55,00",
        },
        {
          name: "PLTA - Jawa-Bali (Kuota) Tersebar - 50 MW - 2026 - #1 - Jawa Barat",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "50,00",
        },
        {
          name: "PLTA - Konawe (Bendungan Pelosika PUPR) - 10.5 MW - 2028 - #1 - Sulawesi Tenggara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,50",
        },
        {
          name: "PLTA - Konawe(Bendungan Pelosika PUPR) - 10.5 MW - 2028 - #2 - Sulawesi Tenggara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,50",
        },
        {
          name: "PLTA - Kumbih-3 - 45 MW - 2025 - #1 - Aceh",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "45,00",
        },
        {
          name: "PLTA - Lambakan - 18.2 MW - 2025 - #1 - Kalimantan Timur",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "18,20",
        },
        {
          name: "PLTA - Malea (FTP 2) - 45 MW - 2021 - #1 - Sulawesi Selatan",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "45,00",
        },
        {
          name: "PLTA - Malea (FTP 2) - 45 MW - 2021 - #2 - Sulawesi Selatan",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "45,00",
        },
        {
          name: "PLTA - Masang-2 (FTP2) - 44 MW - 2027 - #1",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "44,00",
        },
        {
          name: "PLTA - Orya 2 - 14 MW - 2026 - #1 - Papua",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "14,00",
        },
        {
          name: "PLTA - Peusangan 1-2 - 43 MW - 2022 - #2 - Aceh",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "43,00",
        },
        {
          name: "PLTA - Peusangan 1-2 - 45 MW - 2023 - #1 - Aceh",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "45,00",
        },
        {
          name: "PLTA - Pokko - 41.5 MW - 2026 - #1 - Sulawesi Selatan",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "41,50",
        },
        {
          name: "PLTA - Pokko - 41.5 MW - 2026 - #2 - Sulawesi Selatan",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "41,50",
        },
        {
          name: "PLTA - Pokko - 41.5 MW - 2026 - #3 - Sulawesi Selatan",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "41,50",
        },
        {
          name: "PLTA - Sawangan - 8.3 MW - 2026 - #1 - Sulawesi Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "8,30",
        },
        {
          name: "PLTA - Sawangan - 8.3 MW - 2026 - #2 - Sulawesi Utara",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "8,30",
        },
        {
          name: "PLTA - Sulbagut (Kuota) Tersebar / PLTA Poigar 30 MW - 30 MW - 2025 - #1 - Sulawesi Utara",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "30,00",
        },
        {
          name: "PLTA - Wai Tala - 27 MW - 2029 - #1 - Maluku",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "27,00",
        },
        {
          name: "PLTA - Wai Tala - 27 MW - 2029 - #2 - Maluku",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "27,00",
        },
        {
          name: "PLTA - Wai Tina - 3 MW - 2027 - #1 - Maluku",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTA - Wai Tina - 3 MW - 2027 - #2 - Maluku",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTA - Wai Tina - 3 MW - 2027 - #3 - Maluku",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTA - Wai Tina - 3 MW - 2027 - #4 - Maluku",
          stage: "Procurement Planning",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTA - Watunohu - 22 MW - 2026 - #1 - Sulawesi Tenggara",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "22,00",
        },
        {
          name: "PLTB - Jawa Barat - 60 MW - 2024 - #1 - Jawa Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "60,00",
        },
        {
          name: "PLTB - Maubesi - 2 MW - 2022 - #1 - Nusa Tenggara Timur",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTB - Sumba (Kuota) Tersebar - 3 MW - 2023 - #1 - Nusa Tenggara Timur",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTB - Tanah Laut - 30 MW - 2023 - #1 - Kalimantan Selatan",
          stage: "Procurement",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "30,00",
        },
        {
          name: "PLTB - Tanah Laut - 40 MW - 2024 - #2 - Kalimantan Selatan",
          stage: "Procurement",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "40,00",
        },
        {
          name: "PLTBio - Bacan (Kuota) Tersebar - 4 MW - 2024 - #1 - Maluku Utara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "4,00",
        },
        {
          name: "PLTBio - Dobo 2 - 5 MW - 2024 - #1 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - Dobo 2 - 5 MW - 2024 - #2 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - Halmahera (Kuota) Tersebar - 10 MW - 2023 - #1 - Maluku Utara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Kalseltengtimra (Kuota) Tersebar - 10 MW - 2024 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Kalseltengtimra (Kuota) Tersebar - 10 MW - 2025 - #1 - Kalimantan Timur",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Karang Anyer - 1 MW - 2022 - #1 - Jambi",
          stage: "Procurement",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "1,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 1.2 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "1,20",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 10 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 10 MW - 2024 - #1 - Kalimantan Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 10 MW - 2026 - #1 - Kalimantan Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 2 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 6 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 7 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "7,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar / PLTBM Kuala Mandor - 5 MW - 2022 - #1 - Kalimantan Barat",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - Khatulistiwa (Kuota) Tersebar - 5 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - Langgur 2 - 10 MW - 2024 - #1 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Langsa - 10 MW - 2022 - #1 - Aceh",
          stage: "Procurement",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Namlea 2 - 10 MW - 2024 - #1 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - PLTBg Air Upas - 2 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTBio - PLTBg Kendawangan - 2.5 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,50",
        },
        {
          name: "PLTBio - PLTBg Nanga Tayap - 2.5 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,50",
        },
        {
          name: "PLTBio - PLTBg Sei Melayu - 2.5 MW - 2023 - #1 - Kalimantan Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,50",
        },
        {
          name: "PLTBio - PLTBio (Kuota) Kepulauan Sumut - 3 MW - 2024 - #1 - Sumatera Utara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTBio - PLTBio Bangka (Kuota) Tersebar / PLTBg Arung Dalam - 2 MW - 2021 - #1 - Kepulauan Bangka Belitung",
          stage: "COD",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTBio - PLTBio Bangka (Kuota) Tersebar - 2 MW - 2022 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTBio - PLTBio Bangka (Kuota) Tersebar - 5 MW - 2023 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - PLTBio Bangka (Kuota) Tersebar - 5 MW - 2025 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBio - PLTBio Belitung (Kuota) Tersebar - 6 MW - 2024 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTBio - PLTBio Belitung (Kuota) Tersebar - 6 MW - 2024 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTBio - PLTBio Kepri (Kuota) Tersebar - 2.4 MW - 2024 - #1 - Kepulauan Riau",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,40",
        },
        {
          name: "PLTBio - PLTBio Kepri (Kuota) Tersebar - 4 MW - 2022 - #1 - Kepulauan Riau",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "4,00",
        },
        {
          name: "PLTBio - PLTBio Sumatera (Kuota) Tersebar / PLTBg Pasir Mandoge - 2 MW - 2022 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTBio - PLTBio Sumatera (Kuota) Tersebar - 3 MW - 2025 - #1 - Sumatera Utara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTBio - Rantau Sakti (EBTKE) - 1 MW - 2022 - #1 - Riau",
          stage: "COD",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "1,00",
        },
        {
          name: "PLTBio - Sanana 2 - 10 MW - 2024 - #1 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Saumlaki 2 - 10 MW - 2024 - #1 - ",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Seram (Kuota) Tersebar - 6 MW - 2023 - #1 - Maluku",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTBio - Simeulue (Kuota) Tersebar - 3 MW - 2023 - #1 - Aceh",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTBio - Sulbagsel (Kuota) Tersebar - 10 MW - 2025 - #1 - Sulawesi Tenggara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Sulbagsel (Kuota) Tersebar - 10 MW - 2026 - #1 - Sulawesi Tengah",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Sulbagut (Kuota) Tersebar - 10 MW - 2025 - #1 - Sulawesi Utara",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Ujung Batu - 3 MW - 2023 - #1 - Riau",
          stage: "COD",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTBio - Weda - 5 MW - 2028 - #1 - Maluku Utara",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTBm - Deli Serdang - 9.9 MW - 2023 - #1 - Sumatera Utara",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "9,90",
        },
        {
          name: "PLTBm - Kaimana 2 - 10 MW - 2028 - #1 - Papua Barat",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBm - Merauke 3 - 10 MW - 2024 - #2 - Papua",
          stage: "OBC",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBm - Sadai Bangka Selatan - 10 MW - 2023 - #1 - Kepulauan Bangka Belitung",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBm - Sumba (Kuota) Tersebar / PLTBM Bodo Hula - 1 MW - 2021 - #1 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "1,00",
        },
        {
          name: "PLTBm - Sumbawa-Bima (Kuota) Tersebar - 10 MW - 2024 - #1 - Nusa Tenggara Barat",
          stage: "Procurement Planning",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTBio - Tamiang - 3 MW - 2022 - #1 - Aceh",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTBm - Tanjung Semanto - 9.8 MW - 2022 - #1 - Aceh",
          stage: "Konstruksi",
          type: "Other",
          category: "EBT",
          owner: "PLN",
          capacity: "9,80",
        },
        {
          name: "PLTD - Sarmi - 5 MW - 2022 - #1 - Papua",
          stage: "OBC",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "5,00",
        },
        {
          name: "PLTG - Kaltim Peaker 2 - 100 MW - 2023 - #1 - ",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTG/MG - Bangkanai (FTP2) - 70 MW - 2021 - #1 - Kalimantan Tengah",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "70,00",
        },
        {
          name: "PLTG/MG - Bangkanai (FTP2) - 70 MW - 2021 - #2 - Kalimantan Tengah",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "70,00",
        },
        {
          name: "PLTG/MG - Belitung 1 - 21 MW - 2023 - #1 - Kepulauan Bangka Belitung",
          stage: "Procurement Planning",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "21,00",
        },
        {
          name: "PLTG/MG - Kaltimra (Eks.Tarakan) - 20 MW - 2030 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "20,00",
        },
        {
          name: "PLTG/MG - MPP Sulselbar - 60 MW - 2022 - #1 - Sulawesi Tenggara",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "60,00",
        },
        {
          name: "PLTG/MG - MPP Sulselbar - 60 MW - 2023 - #2 - Sulawesi Tenggara",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "60,00",
        },
        {
          name: "PLTG/MG - Sei Menggaris - 20 MW - 2026 - #1 - Kalimantan Utara",
          stage: "OBC",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "20,00",
        },
        {
          name: "PLTG/MG - Sei Menggaris - 20 MW - 2026 - #2 - Kalimantan Utara",
          stage: "OBC",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "20,00",
        },
        {
          name: "PLTGU - Jawa-1 - 880 MW - 2021 - #1 - Jawa Barat",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "880,00",
        },
        {
          name: "PLTGU - Jawa-1 - 880 MW - 2021 - #2 - Jawa Barat",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "880,00",
        },
        {
          name: "PLTGU - Jawa-Bali 1 - 779 MW - 2022 - #1 - ",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "779,00",
        },
        {
          name: "PLTGU - Kalsel 1 - 100 MW - 2030 - #1 - Kalimantan Selatan",
          stage: "OBC",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTGU - Kaltim Add On Blok 2 - 80 MW - 2026 - #1 - ",
          stage: "Tim Verifikasi Validasi (TVV)",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "80,00",
        },
        {
          name: "PLTGU - Lombok Peaker - 10 MW - 2021 - #1 - Nusa Tenggara Barat",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTGU - Muara Karang - 200 MW - 2021 - #2 - DKI Jakarta",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "200,00",
        },
        {
          name: "PLTGU - Muara Tawar Add-on Blok 2 - 150 MW - 2021 - #1 - Jawa Barat",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "150,00",
        },
        {
          name: "PLTGU - Muara Tawar Add-on Blok 3 - 250 MW - 2022 - #1 - Jawa Barat",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTGU - Muara Tawar Add-on Blok 4 - 250 MW - 2022 - #1 - Jawa Barat",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "250,00",
        },
        {
          name: "PLTGU - Riau - 275 MW - 2021 - #1 - Riau",
          stage: "COD",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "275,00",
        },
        {
          name: "PLTGU - Riau Peaker #1 - 100 MW - 2025 - #1 - Riau",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTGU - Riau Peaker #2 - 100 MW - 2025 - #2 - Riau",
          stage: "Konstruksi",
          type: "Gas Based",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTM - Aek Pungga - 2 MW - 2024 - #1 - Sumatera Utara",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "2,00",
        },
        {
          name: "PLTM - Aek Sibundong - 10 MW - 2023 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTM - Aek Sibundong - 8 MW - 2024 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "8,00",
        },
        {
          name: "PLTM - Aek Sigeaon - 3.2 MW - 2023 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "3,20",
        },
        {
          name: "PLTM - Aek Sisira Simandame - 4.6 MW - 2021 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "4,60",
        },
        {
          name: "PLTM - Aek Situmandi - 7.5 MW - 2024 - #1 - Sumatera Utara",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "7,50",
        },
        {
          name: "PLTM - Aek Tomuan-1 - 8 MW - 2024 - #1 - Sumatera Utara",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "8,00",
        },
        {
          name: "PLTM - Alani - 5.6 MW - 2030 - #1 - Sulawesi Tengah",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "5,60",
        },
        {
          name: "PLTM - Alur Cincin/Bener Meriah - 7.2 MW - 2023 - #1 - Aceh",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "7,20",
        },
        {
          name: "PLTM - Amai - 1.08 MW - 2028 - #1 - Papua",
          stage: "OBC",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "1,08",
        },
        {
          name: "PLTM - Anggoci - 9 MW - 2021 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "9,00",
        },
        {
          name: "PLTM - Banyubiru - 0.17 MW - 2023 - #1 - Jawa Tengah",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "0,17",
        },
        {
          name: "PLTM - Batang Toru 1 - 7.5 MW - 2024 - #1 - Sumatera Utara",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "7,50",
        },
        {
          name: "PLTM - Batang Toru 3 - 10 MW - 2023 - #1 - Sumatera Utara",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTM - Batang Toru 4 - 10 MW - 2024 - #1 - Sumatera Utara",
          stage: "Procurement",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTM - Batang Toru 5 - 7.5 MW - 2024 - #1 - Sumatera Utara",
          stage: "Konstruksi",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "7,50",
        },
        {
          name: "PLTM - Batu Brak - 7.7 MW - 2022 - #1 - Lampung",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "7,70",
        },
        {
          name: "PLTM - Batu Gajah - 10 MW - 2023 - #1 - Sumatera Utara",
          stage: "COD",
          type: "Hydro",
          category: "EBT",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTU - Alor - 3 MW - 2025 - #1 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTU - Alor - 3 MW - 2025 - #2 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "3,00",
        },
        {
          name: "PLTU - Atambua - 6 MW - 2027 - #1 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTU - Atambua - 6 MW - 2027 - #2 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTU - Atambua - 6 MW - 2027 - #3 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTU - Atambua - 6 MW - 2027 - #4 - Nusa Tenggara Timur",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "6,00",
        },
        {
          name: "PLTU - Bima (FTP 1) - 10 MW - 2029 - #1 - Nusa Tenggara Barat",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTU - Bima (FTP 1) - 10 MW - 2029 - #2 - Nusa Tenggara Barat",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "10,00",
        },
        {
          name: "PLTU - Jambi-1 - 300 MW - 2027 - #1 - Jambi",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "300,00",
        },
        {
          name: "PLTU - Jambi-1 - 300 MW - 2027 - #2 - Jambi",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "300,00",
        },
        {
          name: "PLTU - Jambi-2 - 300 MW - 2026 - #1 - Jambi",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "300,00",
        },
        {
          name: "PLTU - Jambi-2 - 300 MW - 2026 - #2 - Jambi",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "300,00",
        },
        {
          name: "PLTU - Jawa Tengah (PPP) - 950 MW - 2021 - #1 - Jawa Tengah",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "950,00",
        },
        {
          name: "PLTU - Jawa Tengah (PPP) - 950 MW - 2021 - #2 - Jawa Tengah",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "950,00",
        },
        {
          name: "PLTU - Jawa-1 (FTP2) - 924 MW - 2022 - #1 - Jawa Barat",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "924,00",
        },
        {
          name: "PLTU - Jawa-10 - 1000 MW - 2026 - #1 - Banten",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "1.000,00",
        },
        {
          name: "PLTU - Jawa-3 (FTP2) - 660 MW - 2025 - #1 - Jawa Barat",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "660,00",
        },
        {
          name: "PLTU - Jawa-3 (FTP2) - 660 MW - 2026 - #2 - Jawa Barat",
          stage: "Procurement",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "660,00",
        },
        {
          name: "PLTU - Jawa-4 (FTP2) - 1000 MW - 2021 - #1 - Jawa Tengah",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "1.000,00",
        },
        {
          name: "PLTU - Jawa-4 (FTP2) - 1000 MW - 2021 - #2 - Jawa Tengah",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "1.000,00",
        },
        {
          name: "PLTU - Jawa-9 - 1000 MW - 2025 - #1 - Banten",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "1.000,00",
        },
        {
          name: "PLTU - Kalbar 1 - 100 MW - 2021 - #2 - Kalimantan Barat",
          stage: "COD",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTU - Kalselteng 2 - 100 MW - 2022 - #1 - Kalimantan Selatan",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTU - Kalselteng 2 - 100 MW - 2022 - #2 - Kalimantan Selatan",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "100,00",
        },
        {
          name: "PLTU - Kotabaru - 7 MW - 2025 - #1 - Kalimantan Selatan",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "7,00",
        },
        {
          name: "PLTU - Kotabaru - 7 MW - 2025 - #2 - Kalimantan Selatan",
          stage: "Konstruksi",
          type: "PLTU",
          category: "Thermal",
          owner: "PLN",
          capacity: "7,00",
        },
      ],
    };
  },
  mounted() {
    this.getDataThermal("all");
    this.getDataEbt("all");
  },
  methods: {
    async getDataGenerationAdditional(typeAdditional, typeGeneration) {
      let param = Object.assign({
        typeAdditional: typeAdditional,
        typeGeneration: typeGeneration,
      });
      const res = await apiGeneration.getDataGenerationAdditional(param);
      if (res && res.status == 200) {
        return res.data.data;
      }

      return [];
    },

    async getDataThermal(typeGeneration) {
      this.thermal = await this.getDataGenerationAdditional(
        "thermal",
        typeGeneration
      );
    },

    async getDataEbt(typeGeneration) {
      this.ebt = await this.getDataGenerationAdditional("ebt", typeGeneration);
    },

    selectTabThermal(tab) {
      this.selectedTabThermal = tab;
      this.getDataThermal(tab);
    },

    selectTabEbt(tab) {
      this.selectedTabEbt = tab;
      this.getDataEbt(tab);
    },

    onShowModalGenerationCapacity(owner, category, type) {
      this.filter = {
        owner: owner,
        type: type,
        category: category,
      };
      this.modalGenerationCapacity.show = true;
    },
    onCloseModalGenerationCapacity(value) {
      this.modalGenerationCapacity.show = value;
    },
  },
};
</script>

<style>
.tab-link {
  cursor: pointer;
}

.tab-selected {
  color: #00a3e9;
}
</style>
